module.exports = __webpack_public_path__ + "img/document.3ee6fe44.svg";